// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type AttachmentVariantUrlQueryVariables = Types.Exact<{
  attachmentId: Types.Scalars['ID']['input'];
  variant: Types.Scalars['String']['input'];
}>;


export type AttachmentVariantUrlQuery = { __typename?: 'Query', attachmentVariantUrl: string };


export const AttachmentVariantUrlDocument = gql`
    query AttachmentVariantUrl($attachmentId: ID!, $variant: String!) {
  attachmentVariantUrl(attachmentId: $attachmentId, variant: $variant)
}
    `;

/**
 * __useAttachmentVariantUrlQuery__
 *
 * To run a query within a React component, call `useAttachmentVariantUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentVariantUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentVariantUrlQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useAttachmentVariantUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables> & ({ variables: AttachmentVariantUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>(AttachmentVariantUrlDocument, options);
      }
export function useAttachmentVariantUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>(AttachmentVariantUrlDocument, options);
        }
// @ts-ignore
export function useAttachmentVariantUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>;
export function useAttachmentVariantUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AttachmentVariantUrlQuery | undefined, AttachmentVariantUrlQueryVariables>;
export function useAttachmentVariantUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>(AttachmentVariantUrlDocument, options);
        }
export type AttachmentVariantUrlQueryHookResult = ReturnType<typeof useAttachmentVariantUrlQuery>;
export type AttachmentVariantUrlLazyQueryHookResult = ReturnType<typeof useAttachmentVariantUrlLazyQuery>;
export type AttachmentVariantUrlSuspenseQueryHookResult = ReturnType<typeof useAttachmentVariantUrlSuspenseQuery>;
export type AttachmentVariantUrlQueryResult = ApolloReactCommon.QueryResult<AttachmentVariantUrlQuery, AttachmentVariantUrlQueryVariables>;